import styled from '@emotion/styled';

export const BreadcrumbsContainer = styled.div`
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  padding-right: 11px;
  /* height: 46px; */
  display: flex;
  align-items: center;
`;
